// Search
$('.btn-search').on('click', function (e) {
    e.preventDefault();
    $('.main-search-wrap').fadeIn('fast', function () {
        $('input.field-search').focus();
    });
    $(this).toggleAttrVal('aria-expanded', 'true');
    $('.btn-close-search').toggleAttrVal('aria-expanded', 'true', 'false');
    $('#search').toggleAttrVal('aria-hidden', 'true', 'false');
});

function closeSearch () {
    $('.main-search-wrap').fadeOut('fast', function () {
        $('input.field-search').blur();
    });
    $(this).toggleAttrVal('aria-expanded', 'false');
    $('.btn-search').toggleAttrVal('aria-expanded', 'false');
}

$('.btn-close-search').on('click', function (e) {
    e.preventDefault();
    closeSearch();
});

$(document).keyup(function(e) {
    if (e.key === "Escape") {
        closeSearch();
    }
});

jQuery(once('se-searchtrap', 'body')).on('keydown', '.btn-submit-search', function (e) {
    if (e.keyCode === 9) {
        e.preventDefault();
        jQuery('.btn-close-search').focus();
    }
    // if(e.keyCode === 13) {
    //     e.preventDefault();
    //     closeSearch();
    // }
});